<template>
  <div>
    <el-dialog title="编辑" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
        <el-form-item label="身份名称">
          <el-input v-model="form.name" disabled />
        </el-form-item>
        <el-form-item label="分组名称" prop="defaultProfitRatioId">
          <el-select v-model="form.defaultProfitRatioId" placeholder="请选择">
            <el-option v-for="item in sysProfitRatio" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <span class="goup" @click="handleDiscount">添加分组</span>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" placeholder="请输入描述" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
    <discount-vue ref="discountAdd" @created="getSysProfitRatio()" />
  </div>
</template>

<script>
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import customerLevelApi from '@/api/sys/customerLevel'
import discountVue from '@/views/system/discount/add.vue'
function initFormBean() {
  const formBean = {
    name: null,
    defaultProfitRatioId: null,
    description: null,
  }
  return formBean
}

export default {
  components: { discountVue },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: '请输入折扣分组', trigger: 'blur' }],
        defaultProfitRatioId: [{ required: true, message: '请选择分组', trigger: 'change' }],
      },
      sysProfitRatio: []
    }
  },
  created() {
    this.getSysProfitRatio()
  },
  methods: {
    getSysProfitRatio() {
      sysProfitRatioApi.findOptions({isEnable: true}).then(data => { this.sysProfitRatio = data.data })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.form.id > 0) {
            customerLevelApi.update(this.form).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDiscount() {
      this.$refs.discountAdd.handleCreate()
    },

  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-form-item {
  margin-right: 65px;
  position: relative;
}
.goup {
  font-size: 14px;
  color: #1596cd;
  position: absolute;
  right: -65px;
  top: 0;
  cursor: pointer;
}
</style>
